/**
 * Determines the postal code based on user location and profile address.
 * Defaults to the user entered postal code which is the userLocationPostalCode
 * but if it doesn't exist, will fallback to the postal code from Identity service which is the profileAddressPostalCode.
 * @param {string} userLocationPostalCode - The postal code from the user's location.
 * @param {string} profileAddressPostalCode - The postal code from the user's profile address.
 * @returns {string} The determined postal code.
 */
const determinePostalCode = ({ userLocationPostalCode, profileAddressPostalCode }) => {
  return userLocationPostalCode || profileAddressPostalCode || '';
};

export default determinePostalCode;
